import {
  initialState,
  Actions,
  State,
  GET_ONE_CONTACT,
  GET_ONE_CONTACT_SUCCESS,
  GET_ONE_CONTACT_ERROR,
  RESET_GET_ONE_CONTACT,
} from '../../types/contact/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_CONTACT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_CONTACT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_CONTACT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_CONTACT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
